import React from "react";
import {
	Box,
	Text,
	Flex,
	Icon,
	HStack,
	InputGroup,
	Input,
	IconButton,
	InputRightElement,
	Button,
	Spacer,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	useMediaQuery,
	Link,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { FaThumbsUp, FaCog, FaTrash } from "react-icons/fa";
import { BsArrowDown } from "react-icons/bs";
import { Link as ReachLink } from "react-router-dom";
import { UploadIcon } from "components/Icons/Icons";
import { DeleteIcon } from "components/Icons/Icons";

const data = [
	// Add your data objects here
	{
		index_name: "csvdata-3b64a7bsvc.us-east-1-aws",
		environment: "us-east-1-aws",
		metric: "euclidean",
		pod_type: "p1.x1",
		dimensions: 1536,
		pods_per_replica: 1,
		replicas: 1,
		total_pods: 1,
		empty: "",
	},
	{
		index_name: "csvdata-3b64a7bsvc.us-east-1-aws",
		environment: "us-east-1-aws",
		metric: "euclidean",
		pod_type: "p1.x1",
		dimensions: 1536,
		pods_per_replica: 1,
		replicas: 1,
		total_pods: 1,
		empty: "",
	},
	{
		index_name: "csvdata-3b64a7bsvc.us-east-1-aws",
		environment: "us-east-1-aws",
		metric: "euclidean",
		pod_type: "p1.x1",
		dimensions: 1536,
		pods_per_replica: 1,
		replicas: 1,
		total_pods: 1,
		empty: "",
	},
	{
		index_name: "csvdata-3b64a7bsvc.us-east-1-aws",
		environment: "us-east-1-aws",
		metric: "euclidean",
		pod_type: "p1.x1",
		dimensions: 1536,
		pods_per_replica: 1,
		replicas: 1,
		total_pods: 1,
		empty: "",
	},
	{
		index_name: "csvdata-3b64a7bsvc.us-east-1-aws",
		environment: "us-east-1-aws",
		metric: "euclidean",
		pod_type: "p1.x1",
		dimensions: 1536,
		pods_per_replica: 1,
		replicas: 1,
		total_pods: 1,
		empty: "",
	},
	{
		index_name: "csvdata-3b64a7bsvc.us-east-1-aws",
		environment: "us-east-1-aws",
		metric: "euclidean",
		pod_type: "p1.x1",
		dimensions: 1536,
		pods_per_replica: 1,
		replicas: 1,
		total_pods: 1,
		empty: "",
	},
	{
		index_name: "csvdata-3b64a7bsvc.us-east-1-aws",
		environment: "us-east-1-aws",
		metric: "euclidean",
		pod_type: "p1.x1",
		dimensions: 1536,
		pods_per_replica: 1,
		replicas: 1,
		total_pods: 1,
		empty: "",
	},
	{
		index_name: "csvdata-3b64a7bsvc.us-east-1-aws",
		environment: "us-east-1-aws",
		metric: "euclidean",
		pod_type: "p1.x1",
		dimensions: 1536,
		pods_per_replica: 1,
		replicas: 1,
		total_pods: 1,
		empty: "",
	},
	{
		index_name: "csvdata-3b64a7bsvc.us-east-1-aws",
		environment: "us-east-1-aws",
		metric: "euclidean",
		pod_type: "p1.x1",
		dimensions: 1536,
		pods_per_replica: 1,
		replicas: 1,
		total_pods: 1,
		empty: "",
	},
];

const headers = [
	"Index Name",
	"Environment",
	"Metric",
	"Pod type",
	"Dimensions",
	"Pods Per Replica",
	"Replicas",
	"Total Pods",
	"",
];
function Indexes() {
	const [isSmallScreen] = useMediaQuery("(max-width: 768px)");

	return (
		<Box pt={{ base: "120px", md: "75px" }}>
			<HStack>
				<InputGroup w="500px" ml={5}>
					<Input
						placeholder="Search"
						bg="#3D3D44"
						py="20px"
						px="24px"
						borderRadius="14px"
					/>
					<InputRightElement
						children={
							<IconButton
								bg="none"
								aria-label="Search database"
								icon={<SearchIcon />}
							/>
						}
					/>
				</InputGroup>
				<Spacer />
				<Flex gap="10px" ms="auto">
					<Button
						bg="#48484F"
						borderRadius="16px"
						fontSize="18px"
						py="20px"
						px="24px"
					>
						Create Index
					</Button>
					<Flex align="center">
						<Icon as={BiDotsHorizontalRounded} boxSize={6} />
					</Flex>
				</Flex>
			</HStack>
			<Box overflowX="auto" mt={5}>
				<Table variant="striped">
					<Thead>
						<Tr>
							{headers.map((header, index) => (
								<Th key={index}>
									<HStack>
										<Text>{header}</Text>
										{index !== headers.length - 1 && <Icon as={BsArrowDown} />}
									</HStack>
								</Th>
							))}
						</Tr>
					</Thead>
					<Tbody>
						{data.map((row, index) => (
							<Tr key={index}>
								{/* Render table data cells here */}
								<Td>
									<Link as={ReachLink} to="indexes/1">
										<Flex direction="column" gap={3}>
											<Text fontSize="20px">csvdata</Text>
											<Text>{row.index_name}</Text>
										</Flex>
									</Link>
								</Td>
								<Td>{row.environment}</Td>
								<Td>{row.metric}</Td>
								<Td>{row.pod_type}</Td>
								<Td>{row.dimensions}</Td>
								<Td>{row.pods_per_replica}</Td>
								<Td>{row.replicas}</Td>
								<Td>{row.total_pods}</Td>
								<Td>{row.empty}</Td>
								<Td>
									<IconButton
										bg="none"
										aria-label="Upvote"
										icon={<UploadIcon />}
										size={isSmallScreen ? "sm" : "md"}
									/>
									<IconButton
										bg="none"
										aria-label="Settings"
										icon={<FaCog />}
										size={isSmallScreen ? "sm" : "md"}
									/>
									<IconButton
										bg="none"
										aria-label="Delete"
										icon={<DeleteIcon />}
										size={isSmallScreen ? "sm" : "md"}
									/>
								</Td>
							</Tr>
						))}
					</Tbody>
				</Table>
			</Box>
		</Box>
	);
}

export default Indexes;
